const ProfileLogout: React.FC = () => (
  <button className="text-accent font-family-semibold" id="logout-button">
    Logout
  </button>
);

export default ProfileLogout;
